import {
  CLEAR_FETCH_ENTITY_PROFILE_AD_STATES,
  FETCH_ENTITY_PROFILE_AD_FAILURE,
  FETCH_ENTITY_PROFILE_AD_SUCCESS,
  REQUEST_ENTITY_PROFILE_FETCH_AD,
} from "./entity.location.types";

let initialState = {
  reload: false,
  response: {},
  error: null,
  loading: false,
};

const fetchEntityProfileAdReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_ENTITY_PROFILE_FETCH_AD:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_ENTITY_PROFILE_AD_SUCCESS:
      return {
        ...state,
        loading: false,
        response: action.payload,
        reload: false,
      };

    case FETCH_ENTITY_PROFILE_AD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        reload: false,
      };

    case CLEAR_FETCH_ENTITY_PROFILE_AD_STATES:
      return {
        ...state,
        loading: false,
        response: {},
        error: null,
        reload: false,
      };

    default:
      return state;
  }
};

export default fetchEntityProfileAdReducer;
